import { Component, Prop, Vue } from 'vue-property-decorator';
import ChatWindow from 'vue-advanced-chat';
import NotificationModule from '@/store/modules/notificacion.module';
import NotificationCounterModule from '@/store/modules/contadorNotificaciones.module';
import CollaborativeAreaModule from '@/store/modules/collaborative-area.module';
import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import {  itiSignalRService, i18n } from '@/iti-core-vue';
import { Notification } from '@/shared/dtos/notificacion';
import { NotificationType } from '@/shared/enums/NotificationType';
import fileModule from '@/store/modules/file.module';
import moment from 'moment';

@Component({
    components: {
        ChatWindow
    },
})

export default class NotificacionCard extends Vue {
    
    @Prop()
    public notificacion!: Notification;

    @Prop()
    public esInferior!: boolean;
    
    public get mostrarAutor(): boolean{
        if(this.notificacion.notificationContent && this.notificacion.notificationContent.author === ''){
            return false;
        }
        if((this.notificacion.sourceUser != undefined) || (this.notificacion.notificationContent != undefined)){
            var idOrigen: number = this.notificacion.sourceUser as number;
            if(this.notificacion.notificationContent){
                idOrigen = this.notificacion.notificationContent.type;
            }
            if(idOrigen > 0){
                return true;
            }
            else{
                switch(idOrigen){
                    case NotificationType.Synergies: return false;
                    case NotificationType.Chat: return true;
                    case NotificationType.System: return false;
                    case NotificationType.Document: return true;
                    case NotificationType.Event: return true;
                    case NotificationType.Forum: return true;
                    case NotificationType.Default: return false;
                    default: return false;
                }
            }
        }
        return false;
    }
    public get notificationText(): string{
        if(this.notificacion.notificationContent){
            return this.notificacion.notificationContent.notificationText;
        }
        else{
            return this.notificacion.text;
        }
    }
    public get notificationAmbit(): string{
        if(this.notificacion.notificationContent){
            return this.notificacion.notificationContent.ambitName;
        }
        else{
            return '';
        }
    }
    public get notificationAuthor(): string{
        if(this.notificacion.notificationContent){
            return this.notificacion.notificationContent.author;
        }
        else{
            return '';
        }
    }
    public get notificationDate(): string{
        if(this.notificacion.notificationContent && this.notificacion.notificationContent.date){
            return this.dateString(this.notificacion.notificationContent.date);
        }
        else{
            return this.dateString(this.notificacion.creationDate);
        }
    }

    dateString(date: Date): string{
        return moment(date).format('DD-MM-YYYY HH:mm');
    }

    public get colorMensaje(): string{
        if(this.notificacion.isRead){
            return '#CBD4C2';
        }
        else{
            return '#B7C65D';
        }
    }

    public get icon(): string{
        if(this.notificacion.sourceUser != undefined){
            var idOrigen: number = this.notificacion.sourceUser;
            if(this.notificacion.notificationContent){
                idOrigen = this.notificacion.notificationContent.type;
            }
            if(idOrigen > 0){
                return 'mdi-mail';
            }
            else{
                switch(idOrigen){
                    case NotificationType.Synergies: return 'mdi-share';
                    case NotificationType.Chat: return 'mdi-chat';
                    case NotificationType.System: return 'mdi-wrench';
                    case NotificationType.Document: return 'mdi-file-document';
                    case NotificationType.Event: return 'mdi-calendar';
                    case NotificationType.Forum: return 'mdi-chat';
                    case NotificationType.Default: return 'mdi-article';
                    default: return 'mdi-article';
                }
            }
        }
        return 'mdi-article';
    }

    public get mensajeOrigen(): string{
        if(this.notificacion.sourceUser != undefined){
            var idOrigen: number = this.notificacion.sourceUser;
            if(this.notificacion.notificationContent){
                idOrigen = this.notificacion.notificationContent.type;
            }
            if(this.notificacion.notificationContent && this.notificacion.notificationContent.header){
                return this.notificacion.notificationContent.header;
            }
            if(idOrigen > 0){
                return i18n.tc('notificaciones.mensajeDe') + this.notificacion.sourceUserName;
            }
            else{
                switch(idOrigen){
                    case NotificationType.Synergies: return i18n.tc('notificaciones.sinergias');
                    case NotificationType.Chat: return i18n.tc('notificaciones.chat');
                    case NotificationType.System: return i18n.tc('notificaciones.sistema');
                    case NotificationType.Document: return i18n.tc('notificaciones.documento');
                    case NotificationType.Event: return i18n.tc('notificaciones.evento');
                    case NotificationType.Forum: return i18n.tc('notificaciones.foro');
                    default: return i18n.tc('notificaciones.default');
                }
            }
        }
        return i18n.tc('notificaciones.errorOrigen');
    }

    public created(){
    }

    public marcarLeido(){
        //Si es una notificacion de chat marcamos como leidos todas las notificaciones de ese chat
        if(this.notificacion.sourceUser == -2){
            this.marcarLeidoSala();
        }
        else{
            NotificationModule.markNotificationAsRead(this.notificacion.id);
            NotificationCounterModule.decrementCounter();
            this.notificacion.isRead = true;
        }
    }
    public marcarLeidoSala(){
        this.$emit('leerSala', this.notificacion.idEventSource);
    }

    public irAOrigen(){
        if(this.notificacion.sourceUser){
            var notificationType: number = this.notificacion.sourceUser;
            if(this.notificacion.notificationContent){
                notificationType = this.notificacion.notificationContent.type;
            }
            if(notificationType > 0){
                this.$router.push({ name: 'NotificacionFormulario', params: { id: notificationType+'' } });
            }
            else{
                switch(notificationType){
                    case NotificationType.Chat: {
                        if(this.notificacion.idEventSource){
                            if(!this.notificacion.isRead){
                                this.marcarLeido();
                            }
                            var idOrigenEvento = this.notificacion.idEventSource;
                            this.$router.push({ name: 'ChatUnaSala', params: { id: idOrigenEvento } });
                        }
                        break;
                    }
                    case NotificationType.Forum: {
                        if(this.notificacion.idEventSource){
                            if(!this.notificacion.isRead){
                                this.marcarLeido();
                            }
                            var idOrigenEvento = this.notificacion.idEventSource;
                            if(this.notificacion.notificationContent.notificationSourceId > 0){
                                this.$router.push({ name: 'Foro-Post', params: { ambitId: idOrigenEvento, postId: this.notificacion.notificationContent.notificationSourceId+"" } });
                            }
                            else{
                                this.$router.push({ name: 'Foro', params: { ambitId: idOrigenEvento } });
                            }
                        }
                        break;
                    }
                    case NotificationType.Document: {
                        if(!this.notificacion.isRead){
                            this.marcarLeido();
                        }
                        if(this.notificacion.idEventSource){
                            var idOrigenEvento = this.notificacion.idEventSource;
                            var fileID: number = this.notificacion.notificationContent.notificationSourceId;
                            const e = {
                                id: fileID,
                                ambitId: idOrigenEvento
                            }
                            fileModule.setFileToShow(e);  
                            this.$router.push({ name: 'GestionDocumentalAreaColaborativa', params: { collaborativeAreaId: idOrigenEvento } });
                        }
                        break;
                    }
                    case NotificationType.Event: {
                        if(!this.notificacion.isRead){
                            this.marcarLeido();
                        }
                        if(this.notificacion.idEventSource){
                            var idOrigenEvento = this.notificacion.idEventSource;
                            this.$router.push({ name: 'CalendarioAreaColaborativa', params: { collaborativeAreaId: idOrigenEvento } });
                        }
                        break;
                    }
                    default: {
                        if(!this.notificacion.isRead){
                            this.marcarLeido();
                        }
                        if(this.notificacion.idEventSource){
                            var idOrigenEvento = this.notificacion.idEventSource;
                            this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: idOrigenEvento } });
                        }
                        break;
                    }
                }
            }
        }
    }
}
